<template>
    <div class="base-calendar-page">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'BaseCalendar'
    }
</script>

<style scoped>
    .base-calendar-page {
        margin-bottom: 63px;
    }
</style>


// WEBPACK FOOTER //
// src/components/main/pages/base/BaseCalendar.vue